shvenergy.bounce = (function ($) {
    "use strict";
    var timeoutObj = {};
    function clearNamed(named) {
        if (timeoutObj[named]) {
            clearTimeout(timeoutObj[named]);
            timeoutObj[named] = 0;
        }
    }
    function clear(func) {
        clearNamed(func.toString());
    }

    function run(func, ms) {
        runNamed(func.toString(), func, ms);
    }

    function runNamed(named, func, ms) {
        clearNamed(named);
        timeoutObj[named] = setTimeout(func, ms);
    }

	return {
		run: run,
		clear: clear,
		runNamed: runNamed,
		clearNamed: clearNamed
	};
})(jQuery);